// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
window.Vue = Vue
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import Modal from './components/Modal'
import store from './store/index'
import Datepicker from 'vuejs-datepicker'
import VueTippy from 'vue-tippy'
import VueMoment from 'vue-moment'
import VueAnalytics from 'vue-analytics'
import vueSignature from 'vue-signature'
// import JsZip from "jszip";

// DIRECTIVES
import NumberOnly from './Directives/NumberOnly'

// HELPERS
import RationalNumberMath from './Helpers/RationalNumberMath'
window.RationalNumberMath = new RationalNumberMath()

// UI
import Notifications from './Notifications/Notifications.js'
import ToolBar from './components/toolbar/ToolBar.js'
import Pagination from './components/Pagination'
import UiElements from './components/ui/UiElements'

// PROTOTYPES
import file from './prototypes/oxsfs'
const plugin = {
   install() {
      Vue.helpers = file
      Vue.prototype.$file = file
   },
}
Vue.use(plugin)
///

// const botoxs = () => import(/* webpackChunkName: "Botoxs" */"botoxs2");
const botoxs = require('botoxs2')
Vue.use(botoxs)

import Vuex from 'vuex'
Vue.use(Vuex)
// Filters
import './Filters/index'

import CKEditor from 'ckeditor4-vue'

Vue.use(CKEditor)

// Sockets
import io from 'socket.io-client'
import VueSocketio from 'vue-socket.io-extended'

// i18n
import i18n from './lang/i18n'

// Mixins
import Helpers from './Helpers/index'

Vue.mixin(Helpers)
// Vue.mixin(Tour)
Vue.use(UiElements)
// Vue.use(Tour)
Vue.use(Notifications)
Vue.use(ToolBar)
Vue.use(VueResource)
Vue.use(Pagination)
Vue.use(vueSignature)

Vue.use(VueTippy, {
   arrow: true,
   theme: 'translucent',
})

Vue.use(VueMoment)
Vue.use(NumericFilter)
Vue.component('Modal', Modal)
Vue.use(VueAnalytics, {
   id: 'UA-116552070-1',
   router,
})

Vue.use(
   VueSocketio,
   io(process.env.SOCKETS_URL, {
      reconnectionAttempts: 5,
      reconnectionDelay: 3000,
      transports: ['websocket'],
      upgrade: false,
   })
)

Vue.directive('NumberOnly', NumberOnly)

Vue.http.options.root = process.env.BASE_URL_API

if (localStorage['isAdmin']) window.isAdmin = true
Vue.http.interceptors.push(function(request, next) {
   if (localStorage['at']) {
      request.headers.set('authorization', localStorage['at'])
      // request.headers.set("userId", JSON.parse(localStorage["u"])._id);
   }

   next(function(response) {
      if (response.status && response.status === 401) {
         if (!window.isAdmin) {
            removeLocalSorage()
         }
      } else if (response.status && response.status === 403) {
         if (!window.isAdmin) {
            if (response.data.status === 2) {
               alert('אינך מורשה לביצוע פעולה זו')
            }
         }
      }
   })
})

function removeLocalSorage() {
   localStorage.clear()
   location.href = '/'
}

Vue.config.productionTip = false

if (
   (localStorage['u'] &&
      localStorage['allowedPaths'] &&
      localStorage['allowedPaths'] != 'undefined') ||
   localStorage['isAdmin']
) {
   let user = JSON.parse(localStorage['u'])
   window.allowedPaths = JSON.parse(localStorage['allowedPaths'])
   window.companyId = user.companyId
   window.roleId = user.roleId ? user.roleId : null

   const hasNoAuthPaths = ['/', '/login']

   if (hasNoAuthPaths.includes(window.location.pathname)) {
      location.href = '/main/stats'
   }
} else if (
   localStorage['u'] &&
   !localStorage['allowedPaths'] &&
   !localStorage['isAdmin']
) {
   removeLocalSorage()
}
import { NumericFilter } from './Filters/numericFilters'

// import Tour from './services/Tour'
new Vue({
   el: '#app',
   i18n,
   store,
   router,
   render: h => h(App),
   components: {
      App,
      Modal,
      Datepicker,
      Vuex,
   },
   watch: {
      $route(to) {
         localStorage.setItem('component', to.name)
         // Tour.TourService.initTour()
      },
   },
})



// WEBPACK FOOTER //
// ./src/main.js